import React from 'react';
import { DropDown } from './common';
import { connect } from 'react-redux';
import {validatable} from 'components/utils';
import { DuLieuHeThong } from 'api';

class DropDownChonLoaiNamThongKe extends React.Component {
  constructor(props, context) {
    super(props);
    this.state = {
      data: this.props.data
    }
  }

  componentDidMount() {
    if(this.props.data.length == 0) {
      DuLieuHeThong.actions.getNamThongKe.request().then(res => {
        this.props.dispatch({
          type: 'CAPNHAT_DULIEUHETHONG',
          duLieuHeThong: [{
            key: 'namThongKe',
            data: res.data || []
          }]
        })
      })
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.data != this.props.data) {
      this.state.data = nextProps.data;
      this.setState({...this.state})
    }
  }

  onChange(e) {
    this.props.onChange(e);
  }

  render() {
    return (
      <DropDown label={this.props.label} bindValidator={this} channel="formTaoDon" selectedValue={this.props.selectedValue} require={this.props.require} isValid={this.props.isValid} options={this.state.data} keyName='giaTri' valueName='ten' onChange={this.onChange.bind(this)} placeholder={this.props.placeholder} className={'col-input '+this.props.className} name={this.props.name}/>
    )
  }
}

DropDownChonLoaiNamThongKe.defaultProps = {
  className: 'input-group',
  onChange: function () {
    console.log('Need to assign onChange method');
  },
  placeholder: {
    key: '',
    text: 'Chọn...'
  },
  require: false,
  isValid: false,
  name:'',
  label: 'Năm',
  data: []
}

let bindStateToProps = state => {
  return {
    data: state.duLieuHeThong.namThongKe
  }
}

export default connect(bindStateToProps)(validatable(DropDownChonLoaiNamThongKe));


// WEBPACK FOOTER //
// ./src/components/tt-forms/dropdown-chonloainamthongke.jsx